import script from "./MapRight.Layers.AddFiles.vue?vue&type=script&setup=true&lang=js"
export * from "./MapRight.Layers.AddFiles.vue?vue&type=script&setup=true&lang=js"

import "./MapRight.Layers.AddFiles.vue?vue&type=style&index=0&id=fb8bfc22&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb8bfc22"]])

export default __exports__